import React, { lazy, useContext,useEffect } from "react";
import {
  Redirect,
  BrowserRouter as Router,
  Switch,
  Route,
  useHistory
} from "react-router-dom";

/// Css
import "./index.css";
import "./chart.css";
import "./step.css";
/// Layout
import Nav from "./layouts/nav";
import Footer from "./layouts/Footer";
/// Dashboard
import Index from "./components/Dashboard/Index";
/// Table

/// Pages
import Login from "./pages/Login";
import Setting from "./layouts/Setting";
import { ThemeContext } from "../context/ThemeContext";
import ScrollToTop from "./layouts/ScrollToTop";
import Error404 from "./pages/Error404";
import Error400 from "./pages/Error400";
//go one users
import UserCustomer from "./components/goUsers/UserCustomer";
import DeletedUser from "./components/goUsers/DeletedUser";
//go one riders
import EditRiderVehicle from "./components/riders/EditRiderVehicle";
import RiderApplied from "./components/riders/RiderApplied";
import BlockedRider from "./components/riders/BlockedRider";
import RiderDetails from "./components/riders/RiderAcceptDetails";
import EditRider from "./components/riders/EditRider";
import Agenttable from "./components/riders/Agenttable";
import Training from "./components/riders/Training";
import RiderMapView from "./components/riders/RiderMapView";
//pricing
import RiderPricing from "./components/Pricing/AddPrice";
// import Pickanddrop from "./components/Pricing/PriceList";
import Taxes from "./components/Pricing/Taxes";
//commission
import RiderCommission from "./components/Commission/RiderCommission";
//orders
import AllOrders from "./components/orders/AllOrders";
import ShowOrder from "./components/orders/showOrder";
//Geofence
// import Pincode from "./components/pincode/Pincode";
import State from "./components/pincode/State";
import City from "./components/pincode/City";
import PincodeView from "./components/pincode/PinCodeView";
// import Geofence from "./components/pincode/Geofence"
//staffs
import AllStaff from "./components/staff/AllStaff";
import AddNewStaff from "./components/staff/AddNewStaff";
import AllRoles from "./components/roles/AllRoles";
import AddRole from "./components/roles/AddRole";
//service area
import ServiceableArea from "./components/ServiceableArea/ServiceableArea";
// import ServiceArea from "./components/ServiceableArea/ServiceArea";
//marketting
import CustomerNotification from "./components/Marketing/CustomerNotification";
import Banners from "./components/Marketing/Banners";
import MoversCategories from "./components/Marketing/MoversCategories";
import Offers from "./components/Marketing/Offers";
// import LoginScreenGif from "./components/Marketing/LoginScreenGif";
import Coupen from "./components/Offers/Coupen";
import GoCategory from "./components/Marketing/GoCategory";
import TrendingBanners from "./components/Trending/TrendingBanners";
import Cashback from "./components/Marketing/Cashback";
//grocery
import Stores from "./components/Grocery/Stores";
import CategoryManagment from "./components/Grocery/SubStore";
import Products from "./components/Grocery/Products";
import AddProducts from "./components/Grocery/AddProducts";
import Category from "./components/Grocery/Category";
import SubCategory from "./components/Grocery/SubCategory";
//support
import Support from "./components/SupportEmail/Support";
import CustomerSupport from "./components/SupportEmail/CustomerSupport";
//Transactions
import Transaction from "./components/Transactions/Transaction";
import Payout from "./components/Transactions/Payout";
//onboard Partner
import BlockedPartner from "./components/GoPartner/Blocked";
import GoPartner from './components/GoPartner/GoPartner';
import ViewPartner from "./components/GoPartner/ViewPartner";
import PartnerCommission from './components/GoPartner/PartnerCommission'
import AppliedPartners from "./components/GoPartner/AppliedPartners";
import ViewCommission from "./components/GoPartner/ViewCommission";
import ViewPartnerRider from "./components/GoPartner/ViewPartnerRider";
import Taxi from "./layouts/Taxi";
import RiderEarning from "./components/GoPartner/RiderEarning";
//diagnostics
import ViewOrdersList from "./components/Diagonostics/ViewOrdersList";
import HealthCenter from "./components/Diagonostics/HealthCenter";
import Packages from "./components/Diagonostics/Package";
import PackageBanner from "./components/Diagonostics/PackageBanner";
import Test from "./components/Diagonostics/Test";
import SubTests from "./components/Diagonostics/SubTests";
import PackageCategory from "./components/Diagonostics/PackageCategory";
import DeliveryCharge from "./components/Diagonostics/DeliveryCharge";
import RejectedRiders from "./components/riders/RejectedRiders";
import Faq from "./components/FAQ/Faq";
import RiderRegister from "./components/Diagonostics/RiderRegister";
//food
import RestaurantOwner from "./components/FoodAdmin/RestaurantOwner";
import AppliedOwners from "./components/FoodAdmin/AppliedOwners";
import ViewOwner from "./components/FoodAdmin/ViewOwner";
import BlockedOwners from "./components/FoodAdmin/BlockedOwners";
import ViewRestaurant from "./components/FoodAdmin/ViewRestaurant";
import RestaurantList from "./components/FoodAdmin/RestaurantList";
import VerifiedRestaurants from "./components/FoodAdmin/VerifiedRestaurants";
import AppliedRestaurants from "./components/FoodAdmin/AppliedRestaurants";
import BlockedRestaurants from "./components/FoodAdmin/BlockedRestaurants";
import AllItems from "./components/FoodAdmin/AllItems";
import AllAddons from "./components/FoodAdmin/AllAddons";
import AppliedItems from "./components/FoodAdmin/AppliedItems";
import AppliedAddons from "./components/FoodAdmin/AppliedAddons";
import ViewItems from "./components/FoodAdmin/ViewItems";
import ViewAddons from "./components/FoodAdmin/ViewAddons";
import FoodCoupens from "./components/FoodAdmin/FoodCoupens";
import HomeCategory from "./components/FoodAdmin/HomeCategory";
import FoodCampaign from "./components/FoodAdmin/FoodCampaign";
import AppliedCampaign from "./components/FoodAdmin/AppliedCampaign";
import ViewAppliedCampaign from "./components/FoodAdmin/ViewAppliedCampaign";
import FoodBanner from "./components/FoodAdmin/FoodBanner";
import Quotes from "./components/Qoutes/Quotes";
import PaymentOption from "./components/Marketing/PaymentOption";
import BannerCampaignPayment from "./components/FoodAdmin/BannerCampaignPayment";
import FoodAppliedBanner from "./components/FoodAdmin/FoodAppliedBanner";
import ViewFoodOrder from "./components/FoodAdmin/ViewFoodOrder";
import PenaltyRestaurants from "./components/FoodAdmin/PenaltyRestaurants";
import ViewRestaurantPenalty from "./components/FoodAdmin/ViewRestaurantPenalty";
import OrderRatings from "./components/orders/OrderRatings";
import AppUpdate from "./components/AppUpdate/AppUpdate";
import ExpertsList from "./components/Home Services/ExpertsList";
import ApproveExperts from "./components/Home Services/ApproveExperts";
import Subscription from "./components/Home Services/Subscription";
import ServiceCategory from "./components/Home Services/ServiceCategory";
import ViewExperts from "./components/Home Services/ViewExperts";
import OrderDetailsFood from "./components/FoodAdmin/OrderDetailsFood";
import RestaurantItems from "./components/FoodAdmin/RestaurantItems";
import AllOrderList from "./components/OrderListAll/AllOrderList";
import SolvedMenuReviews from "./components/FoodAdmin/SolvedMenuReviews";
import MapPolyLine from "./components/polyLine/PolyLine";
import AllPolyLines from "./components/polyLine/AllPolyLines";
import ViewPolyLine from "./components/polyLine/ViewPolyLine";
import UpdatePolyLine from "./components/polyLine/UpdatePolyLine";
import AirPortOrders from "./components/Go_AirPort/AirPortOrders";
import RentalOrders from "./components/Go_Rentals/RentalOrder";
import RiderOrders from "./components/riders/RiderOrders";
import CategoryAnalytics from "./components/Analytics/CategoryAnalytics"
import AllAnalytics from "./components/Analytics/AllAnalytics";
import AssignedRidesAirport from "./components/Go_AirPort/AssignedRide";
import UnAssignedRidesAirport from "./components/Go_AirPort/UnAssignedRide";
import AssignedRidesRentals from "./components/Go_Rentals/AssignedRideRental";
import UnAssignedRidesRentals from "./components/Go_Rentals/UnAssignedRiderental";
import ViewUpdateStores from "./components/Grocery/ViewUpdateStores";
import WareHouse from "./components/Grocery/WareHouse";
import ViewUpdateWareHouse from "./components/Grocery/ViewUpdateWareHouse";
import ShopAdmin from "./components/Grocery/ShopAdmin";
import GroceryBanners from "./components/Grocery/GroceryBanners";
import MainCategory from "./components/Diagonostics/MainCategory";
import UserAnalytics from "./components/goUsers/UserAnalytics";
import TechnicianLocation from "./components/riders/TechnicianLocation";

const Markup = () => {
  const history=useHistory()
  var permisson=JSON.parse(localStorage.getItem("permissions"));
  const { menuToggle } = useContext(ThemeContext);
  var routes=[]
  if(permisson){
     routes = [
      /// Dashboard
      permisson.includes("Dashboard")?{ url: "", component: Index }:{},
      //rider
      permisson.includes("Riders")?{ url: "riders", component: Agenttable }:{},
      permisson.includes("Riders Applied")?{ url: "rider-applied", component: RiderApplied }:{},
      permisson.includes("Rejected Riders")?{ url: "rejected-riders", component: RejectedRiders }:{},
      permisson.includes("Blocked Riders")?{ url: "blocked-rider", component: BlockedRider }:{},
      permisson.includes("Training")?{ url: "Training", component: Training }:{},
      permisson.includes("Rider Map View")?{ url: "Rider-View", component: TechnicianLocation }:{},
      
      { url: "rider-details/:val/:id", component: RiderDetails },
      { url: "edit-rider/:val/:id", component: EditRider },
      { url: "offline", component: Error404 },
      { url: "400", component: Error400 },
      
      // Users
      permisson.includes("All Users")?{ url: "user-customer", component: UserCustomer }:{},
      permisson.includes("Deleted User")?{ url: "deleted-user", component: DeletedUser }:{},
      
      //pricing
      permisson.includes("Add Price")?{ url: "category-pricing", component: RiderPricing }:{},
      // permisson.includes("Price List")?{ url: "pricing-list", component: Pickanddrop }:{},
      permisson.includes("Taxes")?{ url: "taxes", component: Taxes }:{},
      //commission
      permisson.includes("Riders/Clint Commission")?{ url: "Rider/Clint-Commission", component: RiderCommission }:{},
      //orders
      permisson.includes("AllOrders")?{ url: "all-orders", component: AllOrders }:{},
      permisson.includes("AllOrders")?{ url: "show-order/:id", component: ShowOrder }:{},
      
      //Geofence
      // permisson.includes("States")?{ url: "pincode/:id", component: Pincode }:{},
      permisson.includes("States")?{ url: "pincode-view/:id", component: PincodeView }:{},
      permisson.includes("States")?{ url: "state", component: State }:{},
      permisson.includes("States")?{ url: "city/:id", component: City }:{},
      // permisson.includes("Geofences")?{ url: "geofence", component: Geofence}:{},
      
      //staff
      permisson.includes("All Staff")?{ url: "all-staff", component: AllStaff }:{},
      permisson.includes("All Staff")?{ url: "new-staff", component: AddNewStaff }:{},
      permisson.includes("Roles")?{ url: "all-roles", component: AllRoles }:{},
      permisson.includes("Roles")?{ url: "add-roles", component: AddRole }:{},

      permisson.includes("AirPort Orders")?{ url: "AirPort-Orders", component: AirPortOrders }:{},
      permisson.includes("Airport Assigned Orders")?{ url: "Airport-Assigned-Orders", component: AssignedRidesAirport }:{},
      permisson.includes("Airport UnAssigned Orders")?{ url: "Airport-UnAssigned-Orders", component: UnAssignedRidesAirport }:{},
      permisson.includes("Rentals Assigned Orders")?{ url: "Rentals-Assigned-Orders", component: AssignedRidesRentals }:{},
      permisson.includes("Rentals UnAssigned Orders")?{ url: "Rentals-UnAssigned-Orders", component: UnAssignedRidesRentals }:{},
      permisson.includes("Rentals Orders")?{ url: "Rentals-Orders", component: RentalOrders }:{},
      
      //service area
      permisson.includes("Serviceable Area")?{ url: "serviceable-area", component: ServiceableArea }:{},
      // { url: "service-area", component: ServiceArea },
      //marketting
      
      permisson.includes("Customer Notification")?{ url: "Customer-Notification", component: CustomerNotification }:{},
      permisson.includes("User Analytics")?{ url: "User-Analytics", component: UserAnalytics }:{},
      permisson.includes("Banners")?{ url: "banners", component: Banners }:{},
      permisson.includes("Offers")?{ url: "Offers", component: Offers }:{},
      permisson.includes("Quotes")?{ url: "Quotes", component: Quotes }:{},
      permisson.includes("Payment Options")?{ url: "Payment-Options", component: PaymentOption }:{},
      permisson.includes("Movers Categories")?{ url: "Movers-Categories", component: MoversCategories }:{},
      
      permisson.includes("CashBack")?{ url: "cash-back", component: Cashback }:{},
      // permisson.includes("Login Screen Gif")?{ url: "logingif", component: LoginScreenGif }:{},
      permisson.includes("Go One Coupens")?{ url: "coupens", component: Coupen }:{},
      permisson.includes("Go One Category")?{ url: "go-category", component: GoCategory }:{},
      permisson.includes("Trending Banners")?{ url: "trending-banners", component: TrendingBanners }:{},
      //grocery
      permisson.includes("Stores")?{ url: "stores", component: Stores }:{},
      permisson.includes("Stores")?{ url: "Store-Managment/:id/:type", component: ViewUpdateStores }:{},
      permisson.includes("Sub Store")?{ url: "Sub-Store", component: CategoryManagment}:{},
      permisson.includes("Products")?{ url: "products", component: Products}:{},
      permisson.includes("Products")?{ url: "Product-Managment", component: AddProducts}:{},
      permisson.includes("Grocery Category")?{ url: "Grocery-Category", component: Category}:{},
      permisson.includes("Grocery SubCategory")?{ url: "Grocery-SubCategory", component: SubCategory}:{},
      permisson.includes("WareHouses")?{ url: "WareHouses", component: WareHouse}:{},
      permisson.includes("WareHouses")?{ url: "WareHouse-Managment/:id/:type", component: ViewUpdateWareHouse}:{},
      permisson.includes("Shop Admin")?{ url: "Shop-Admin", component: ShopAdmin}:{},
      permisson.includes("Gocery Banners")?{ url: "Gocery-Banners", component: GroceryBanners}:{},
      // support
      permisson.includes("Rider Support")?{ url: "support", component: Support }:{},
      permisson.includes("Customer Support")?{ url: "customer-support", component: CustomerSupport }:{},
      permisson.includes("FAQ")?{ url: "FAQ", component: Faq }:{},
      //Transactions
      permisson.includes("Transactions")?{ url: "transaction", component: Transaction }:{},
      permisson.includes("Payout Of Rider(Taxi & Movers)")?{ url: "payout", component: Payout }:{},
      //Go Partner
      permisson.includes("Partners")? { url: "partner", component: GoPartner }:{},
      permisson.includes("Blocked Partners")? { url: "blocked-partner", component: BlockedPartner }:{},
      permisson.includes("Applied Partners")? { url: "applied-partners", component: AppliedPartners }:{},
      //Analytics
      permisson.includes("Category Analytics")? { url: "Category-Analytics", component: CategoryAnalytics }:{},
      permisson.includes("All Analytics")? { url: "All-Analytics", component: AllAnalytics }:{},
      { url: "view-partner/:id", component:ViewPartner },
      { url: "view-Rider-Order/:id", component:RiderOrders },
      { url: "partner-commission/:id", component: PartnerCommission },
      { url: "partner-rider/:id", component: ViewPartnerRider },
      { url: "view-commission/:id", component: ViewCommission },
      { url: "rider-earning/:id", component: RiderEarning },
      //payments
      { url: "Taxi", component: Taxi },
      { url: "Taxi", component: Taxi },
      { url: "page-login", component: Login },
      { url: "view-PolyLine", component: ViewPolyLine },
      { url: "Update-PolyLine", component: UpdatePolyLine },
      //diagonostics
      
      { url: "View-Health-Order-List/:id", component: ViewOrdersList },
      permisson.includes("Create Geofence")?{ url: "polyLine", component: MapPolyLine }:{},
      permisson.includes("All Geofence")?{ url: "All-Polylines", component:AllPolyLines }:{},
      permisson.includes("Packages")?{ url: "package", component: Packages }:{},
      permisson.includes("Health Centers")?{ url: "Health-Center", component: HealthCenter }:{},
      permisson.includes("Package Banner")?{ url: "Package-Banner", component: PackageBanner }:{},
      permisson.includes("Tests")?{ url: "Test", component: Test }:{},
      permisson.includes("Sub Tests")?{ url: "Sub-Tests", component: SubTests }:{},
      permisson.includes("Package Category")?{ url: "Package-Category", component: PackageCategory }:{},
      permisson.includes("Main Category")?{ url: "Main-Category", component: MainCategory }:{},
      permisson.includes("Delivery Charge")?{ url: "Delivery-Charge", component: DeliveryCharge }:{},
      permisson.includes("Rider Register")?{ url: "Rider-Register", component: RiderRegister }:{},
      permisson.includes("Restaurant Owners")?{ url: "Restaurant-Owners", component: RestaurantOwner }:{},
      permisson.includes("Applied Owners")?{ url: "Applied-Owners", component: AppliedOwners }:{},
      permisson.includes("Blocked Owners")?{ url: "Blocked-Owners", component: BlockedOwners }:{},
      permisson.includes("Verified Restaurant")?{ url: "Verified-Restaurant", component: VerifiedRestaurants }:{},
      permisson.includes("Applied Restaurants")?{ url: "Applied-Restaurants", component: AppliedRestaurants }:{},
      permisson.includes("Blocked Restaurants")?{ url: "Blocked-Restaurants", component: BlockedRestaurants }:{},
      permisson.includes("All Items")?{ url: "All-Items", component: AllItems }:{},
      permisson.includes("Applied Items")?{ url: "Applied-Items", component: AppliedItems }:{},
      permisson.includes("All Addons")?{ url: "All-Addons", component: AllAddons }:{},
      permisson.includes("Applied Addons")?{ url: "Applied-Addons", component: AppliedAddons }:{},
      permisson.includes("Food Coupens")?{ url: "Food-Coupens", component: FoodCoupens }:{},
      permisson.includes("Home Category")?{ url: "Home-Category", component: HomeCategory }:{},
      permisson.includes("Food Campaign")?{ url: "Food-Campaign", component: FoodCampaign }:{},
      permisson.includes("Applied Campaign")?{ url: "Applied-Campaign", component: AppliedCampaign }:{},
      permisson.includes("Food Banner")?{ url: "Food-Banner", component: FoodBanner }:{},
      permisson.includes("Banner Campaign Payment")?{ url: "Banner-Campaign-Payment", component: BannerCampaignPayment }:{},
      permisson.includes("Applied Banners")?{ url: "Applied-Banners", component: FoodAppliedBanner }:{},
      permisson.includes("Applied Banners")?{ url: "Applied-Banners", component: FoodAppliedBanner }:{},
      permisson.includes("Penalty Restaurants")?{ url: "Penalty-Restaurants", component: PenaltyRestaurants }:{},
      permisson.includes("Order Ratings")?{ url: "Order-Ratings", component: OrderRatings }:{},
      permisson.includes("App Update")?{ url: "App-Update", component: AppUpdate }:{},
      permisson.includes("Experts List")?{ url: "Experts-List", component:ExpertsList  }:{},
      permisson.includes("Applied Experts")?{ url: "Applied-Experts", component:ApproveExperts}:{},
      permisson.includes("Subscription")?{ url: "Subscription", component:Subscription}:{},
      permisson.includes("Service Category")?{ url: "Service-Category", component:ServiceCategory}:{},
      permisson.includes("Menu Reviews")?{ url: "Menu-Reviews", component:SolvedMenuReviews}:{},
      { url: "View-Owner/:id", component: ViewOwner },
      { url: "food-order-details/:id", component: OrderDetailsFood },
      { url: "all-order-list/:orderid/:pagination/:position/:from", component: AllOrderList },
      { url: "Restaurant-Items", component: RestaurantItems },
      { url: "View-Experts/:id", component: ViewExperts },
      { url: "View-Campaign", component: ViewAppliedCampaign },
      { url: "View-Restaurant/:id", component: ViewRestaurant },
      { url: "View-Item/:id", component: ViewItems },
      { url: "View-Addons/:id", component: ViewAddons },
      { url: "Restaurant-List/:id", component: RestaurantList },
      { url: "View-Food-Order/:id", component: ViewFoodOrder },
      { url: "View-Restaurant-Penalty/:id/:type", component: ViewRestaurantPenalty }
      
    ];
  }
  
  let path = window.location.pathname;
  path = path.split("/");
  path = path[path.length - 1];
 
  let pagePath = path.split("-").includes("page");

  return (
    <>
    
      <div
        id={`${!pagePath ? "main-wrapper" : ""}`}
        className={`${!pagePath ? "show" : "mh100vh"}  ${
          menuToggle ? "menu-toggle" : ""
        }`}
      >
        {!pagePath && <Nav />}

        <div className={`${!pagePath ? "content-body" : ""}`}>
          <div
            className={`${!pagePath ? "container-fluid" : ""}`}
            style={{ minHeight: window.screen.height - 240 }}
          >
            <Switch>
              {routes.map((data, i) => (
                <Route
                  key={i}
                  exact
                  path={`/${data.url}`}
                  component={data.component}
                />
              ))}
            </Switch>
          </div>
        </div>
        {/* {!pagePath && <Footer />} */}
      </div>
      <Setting />
      <ScrollToTop />
    </>
  );
};

export default Markup;
